export type AsyncFunction<A extends any[], R> = (...args: A) => Promise<R>;

export function asyncDebounce<A extends any[], R>(func: AsyncFunction<A, R>, waitMs: number): AsyncFunction<A, R> {
    let timeoutId: any;
    return (...a: A) => {
        clearTimeout(timeoutId);
        return new Promise<R>((resolve, reject) => {
            timeoutId = setTimeout(
                () =>
                    func(...a)
                        .then(resolve)
                        .catch(reject),
                waitMs
            );
        });
    };
}
